import { Button, Modal } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { strings } from '../../../assets/strings/all';

const ShouldShareModal = (props) => {
  const { open, close, slug } = props;
  const { cases: caseString, common } = strings;
  const history = useHistory();
  return (
    <Modal size="md" show={open} onHide={close} centered>
      <Modal.Header>
        {' '}
        <div
          style={{
            fontWeight: 'bold',
            fontSize: '1.2rem',
          }}
        >
          {caseString.case_public}
        </div>
      </Modal.Header>
      <Modal.Body style={{ textAlign: 'left' }}>
        <p style={{ fontSize: '14px' }}>{caseString.case_duplication}</p>
      </Modal.Body>
      <Modal.Footer
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-around',
        }}
      >
        <Button
          onClick={() => {
            history.push(`/cases/share/${slug}`);
            close();
          }}
        >
          {common.share}
        </Button>
        <Button variant="outline-danger" onClick={close}>
          {common.cancel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ShouldShareModal;
